import React from "react";

const CLoading = ({texto = "Cargando", isSmall=false}) => {
  
  
  if (isSmall){
    
    return (
      <div className="m10T m10B">
        <p style={{textAlign: "center", fontSize: "12px"}}>
          {texto}<br/>
          <i className="fa fa-circle-o-notch fa-spin"/>
        </p>
      </div>
    );
  }else{
    
    return (
      <div style={{marginTop: "20px"}}>
        <h2 style={{textAlign: "center", fontSize: "26px"}}>
          {texto}<br/>
          <i className="fa fa-circle-o-notch fa-spin"/>
        
        </h2>
      </div>
    );
  }
  
}

export default CLoading;